import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgTakeaway = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m2.106 7.553 1.99-3.982A1.003 1.003 0 0 1 5.023 3h13.957a1 1 0 0 1 .916.552l2 4a1 1 0 1 1-1.79.894l-.544-1.089-1.57 11.774a1 1 0 0 1-.99.868H7a1 1 0 0 1-.991-.868L4.44 7.36l-.545 1.088a1 1 0 0 1-1.79-.894ZM16.586 5H7.414l3 3h3.172l3-3ZM6.382 6.796l2.91 2.911A1 1 0 0 0 10 10h4a1 1 0 0 0 .707-.293l2.911-2.91L16.125 18H7.876L6.382 6.796Z", fill: color }));
};
export default factorySvgIcon(SvgTakeaway);
//# sourceMappingURL=SvgTakeaway.js.map